import type { DocumentsAndRequestsFeatureConfig } from '../type';

export const documentsAndRequests: Partial<DocumentsAndRequestsFeatureConfig> = {
    displayCaseType: true,
    documentsPackageDownload: true,
};
